import ICON_DOWN from '../../../../public/static/ranking/icon-down.svg';
import ICON_NONE from '../../../../public/static/ranking/icon-none.svg';
import ICON_UP from '../../../../public/static/ranking/icon-up.svg';
import ICON_NEW from '../../../../public/static/v4/ranking/icon-new.svg';
import BadgeList from '../../../common/component/BadgeList';
import Text from '../../../common/component/Text';
import {IBadge} from '../../../common/type';
import {IRankingInfo} from '../../common/type';

interface IProps extends IRankingInfo {
  badges: IBadge[];
}

// TODO: 이 컴포넌트는 지우고 RankingLabelV4 사용하자
export default function RankingInfo({ranking, delta, badges}: IProps) {
  const isNew = delta === 'new';
  const iconSrc = !isNew && delta > 0 ? ICON_UP : ICON_DOWN;
  const alt = isNew ? delta : delta > 0 ? 'up' : 'down';

  return (
    <div className="absolute bottom-10 w-full flex-center gap-3">
      <div className="relative h-16 w-60 px-4 bg-dark-grey-01 rounded-5">
        <Text
          as="span"
          className="absolute left-4 top-3 font-number s11-bold-white"
        >
          {ranking}
        </Text>
        {isNew && (
          <img src={ICON_NEW} className="absolute right-4 top-2" alt="new" />
        )}
        {delta === 0 && (
          <img
            src={ICON_NONE}
            alt=""
            width={6}
            height={2}
            className="absolute right-6 top-8"
          />
        )}
        {!isNew && delta !== 0 && (
          <div className="absolute right-4 top-3 flex-center">
            <img
              src={iconSrc}
              alt={alt}
              width={5}
              height={4}
              className="-mt-1"
            />
            <Text
              as="span"
              className="font-number ml-2 s11-bold-white opacity-50"
            >
              {Math.abs(delta)}
            </Text>
          </div>
        )}
      </div>
      <BadgeList
        badges={badges}
        className="w-auto h-16"
        imgTypeClassName="block"
      />
    </div>
  );
}
